<kendo-label
  [text]="'Virus'"
  class="input-label-header"
></kendo-label>
<hr class="input-label-header-hr" />

<p>
  <kendo-dropdownlist style="width: 200px;"
    [data]="hepatitisVirusesList"
    [(ngModel)]="selectedHepatitisVirus"
    [size]="'large'"
    (valueChange)="updateSelections()"
  ></kendo-dropdownlist>
</p>

<app-radio-input-group *ngIf="hepBorCSelected()" #childPopulationsComponent [indication]="populationsIndication" [labelName]="'Populations to include'" [controlName]="'populations'" 
[controlDisplayName]="'Populations'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedPopulationsControlSelectionChangedHandler($event)"></app-radio-input-group>

<app-radio-input-group *ngIf="showScreeningTest()" #childScreeningTestComponent [indication]="screeningTestIndication" [labelName]="'Screening Test'" [controlName]="'screeningtest'" 
[controlDisplayName]="'Screening Test'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedScreeningTestControlSelectionChangedHandler($event)"></app-radio-input-group>

<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>